<div class="relative w-full text-white page-header min-h-screen z-[2]">
  <!-- Hintergrund → ganz hinten -->
  <div class="absolute inset-0 -z-40">
    @if (data?.background?.fields?.file?.url) {
    <img
      class="w-full h-full object-cover"
      [ngSrc]="getImageUrl(data.background.fields.file.url)"
      alt=""
      width="1920"
      height="1080"
      priority
    />
    }
  </div>

  <!-- Portrait → HINTER Overlay -->
  <div
    class="absolute inset-0 -z-30 flex justify-center pt-6 md:pt-10 lg:pt-14"
  >
    @if (data?.heroImage?.fields?.file?.url) {
    <img
      [ngSrc]="getImageUrl(data.heroImage.fields.file.url)"
      alt=""
      class="relative pt-40 md:pt-0  sm:w-[380px] md:w-[460px] lg:w-[540px] object-cover mx-auto"
      width="580"
      height="820"
      priority
    />
    }
  </div>

  <!-- Overlay → über Portrait -->
  <div
    class="absolute inset-0 -z-20 bg-gradient-to-b from-transparent via-black/30 to-black/60"
  ></div>

  <!-- Zusätzlicher Verlauf → nur unten stärker abdunkeln -->
  <div
    class="absolute bottom-0 inset-x-0 -z-15 h-[40vh] bg-gradient-to-t from-black/80 via-black/60 to-transparent"
  ></div>

  <!-- Signature-Text → über Overlay -->
  <div
    class="absolute bottom-48 md:bottom-48 left-1/2 -translate-x-1/2 z-20 w-full px-6 pointer-events-none"
  >
    @if (data?.title) {
    <p
      class="mx-auto max-w-4xl text-center font-bold text-xl sm:text-2xl md:text-3xl lg:text-4xl text-white font-signature leading-snug"
    >
      {{ data.title }}
    </p>
    } @if (data?.text) {
    <p
      class="mt-3 whitespace-break-spaces mx-auto max-w-4xl text-center text-base sm:text-lg md:text-xl lg:text-2xl text-white font-signature leading-snug"
    >
      {{ data.text }}
    </p>
    }
  </div>

  <!-- Logo → links oben über allem -->
  <div
    class="absolute top-8 md:top-20 md:top-28 left-6 md:left-14 lg:left-20 z-30 flex flex-col"
  >
    @if (data?.logo?.fields?.file?.url) {
    <img
      [ngSrc]="getImageUrl(data.logo.fields.file.url)"
      alt="LEAD YOURSELF"
      class="w-[220px] sm:w-[260px] md:w-[320px] lg:w-[380px] object-contain"
      width="420"
      height="180"
    />
    }
  </div>

  <!-- CTA → ganz oben -->
  <div
    class="absolute bottom-[-32px] left-1/2 -translate-x-1/2 z-40 flex justify-center"
  >
    <jnguyen-button
      *ngIf="data?.button?.fields"
      [button]="data.button.fields"
    ></jnguyen-button>
  </div>
</div>
